import OWContainer from 'styles/styled-components/ow-container';
import useController from '../controllers/products-controller';
import { MaterialReactTable } from 'material-react-table';
import { Box, Typography } from '@mui/material';
import TableTabs from 'components/controls/table-tabs';
import { ResponsePlaceDto } from 'features/place/types/dtos';
import React from 'react';

export const ProductsRoute = () => {
    const { tableSettings, placeId, activePlace, handleTabChange, places, handleAddProduct } = useController();

    if (places?.content.length === 0) {
        return (
            <Box>
                <Typography>This website has no places</Typography>
            </Box>
        );
    }

    return (
        <React.Fragment>
            {placeId !== '' && (
                <TableTabs<ResponsePlaceDto>
                    active={!!activePlace}
                    id={placeId}
                    handleAdd={handleAddProduct}
                    handleTabChange={handleTabChange}
                    tabData={places?.content}
                >
                    {activePlace && (
                        <OWContainer>
                            <MaterialReactTable table={tableSettings} />
                        </OWContainer>
                    )}
                </TableTabs>
            )}
        </React.Fragment>
    );
};
